import { Controller } from '@hotwired/stimulus'

export default class PowensWebviewController extends Controller {
  static targets = ['powensWebview'];

  static values = {
    domain: String,
    clientId: String,
    redirectUri: String,
    code: String,
    state: String,
    paymentId: Number,
  }

  connect() {
    this.powensWebviewTarget.options = {
      flow: PowensWebviewFlow.Payment,
      domain: this.domainValue,
      clientId: this.clientIdValue,
      redirectUri: this.redirectUriValue,
      code: this.codeValue,
      state: this.stateValue,
      paymentId: this.paymentIdValue,
    }

    this.powensWebviewTarget.openWebview();

    window.addEventListener('message', (event) => {
      if (event.origin !== window.origin || event.data.type !== 'powensWebviewTermination') return;
      if (this.stateValue !== event.data.data.state) return;

      const queryString = new URLSearchParams(event.data.data).toString();
      window.location.href = `${this.redirectUriValue}?${queryString}`;
    });
  }
}
